<template>
  <form>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="firstName"
                >First Name
                <span class="invalid" v-if="memberForm.firstName == ''">
                  - Field is required</span
                >
              </label>
              <input
                type="text"
                name="firstName"
                v-model="memberForm.firstName"
                placeholder="Enter first name"
                class="form-control"
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="lastName"
                >Last Name
                <span class="invalid" v-if="memberForm.lastName == ''">
                  - Field is required</span
                >
              </label>
              <input
                type="text"
                name="lastName"
                v-model="memberForm.lastName"
                placeholder="Enter last name"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="firstName"
                >Preferred Name
                <span class="invalid" v-if="memberForm.displayName == ''">
                  - Field is required</span
                >
              </label>
              <input
                type="text"
                name="firstName"
                v-model="memberForm.displayName"
                placeholder="Enter preferred name"
                class="form-control"
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="email"
                >Email
                <span class="invalid" v-if="memberForm.email == ''">
                  - Input valid email</span
                >
              </label>
              <input
                type="text"
                name="email"
                v-model="memberForm.email"
                placeholder="Enter email address"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row" v-if="editMember == false">
          <div class="col">
            <div class="form-group">
              <label for="password"
                >Password
                <span class="invalid" v-if="memberForm.password == ''">
                  - Field is required</span
                >
              </label>
              <div class="password-wrapper">
                <input
                  :type="isToggled ? 'text' : 'password'"
                  name="password"
                  v-model="memberForm.password"
                  @keyup="confirmPassword"
                  placeholder="Enter password"
                  :class="`form-control ${passwordMatched}`"
                />
                <div
                  :class="
                    `invalid-feedback ${
                      passwordMatched == 'invalid' ? 'd-block' : 'd-none'
                    } `
                  "
                >
                  Password not matched
                </div>
                <img
                  src="~@/assets/media/icons/visibility.svg"
                  alt="visibility icon"
                  @click="handleTogglePasswordClick"
                  :class="isToggled ? 'is-visible' : ''"
                />
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="confirmPassword"
                >Confirm Password
                <span class="invalid" v-if="memberForm.confirmPassword == ''">
                  - Field is required</span
                >
              </label>
              <div class="password-wrapper">
                <input
                  :type="isToggled ? 'text' : 'password'"
                  name="confirmPassword"
                  v-model="memberForm.confirmPassword"
                  @keyup="confirmPassword"
                  placeholder="Confirm password"
                  :class="`form-control ${passwordMatched}`"
                />
                <div
                  :class="
                    `invalid-feedback ${
                      passwordMatched == 'invalid' ? 'd-block' : 'd-none'
                    } `
                  "
                ></div>
                <img
                  src="~@/assets/media/icons/visibility.svg"
                  alt="visibility icon"
                  @click="handleTogglePasswordClick"
                  :class="isToggled ? 'is-visible' : ''"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="phoneNumber"
                >Phone Number
                <span class="invalid" v-if="memberForm.mobile == ''">
                  - Input valid phone number</span
                >
              </label>
              <input
                type="text"
                name="phone"
                v-model="memberForm.mobile"
                placeholder="Enter phone number"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="userRole"
                >Access Level
                <span class="invalid" v-if="memberForm.role == ''">
                  - Field is required</span
                >
              </label>
              <v-select
                :options="userRoles"
                v-model="memberForm.role"
                name="userRole"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group text-right mb-0">
              <ActionButton
                :label="btnLabel"
                @customEvent="handleAddNewMember"
                :theme="{ primary, secondary, event, danger }"
                :disabled="passwordMatched == 'invalid' ? true : false"
                style="width: auto; margin-left: auto; margin-bottom: 0;margin-top: 10px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import axios from "@/helpers/axios";
import Color from "color";
import { mapActions } from "vuex";
import types from "@/store/auth/types";
import { socketSender } from "@/helpers/socket";

export default {
  name: "AddNewMember",
  components: {
    ActionButton
  },
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      currentUser:
        this.$store.getters.getUser.firstName +
        " " +
        this.$store.getters.getUser.lastName,
      apiOptions: {
        mode: "pagination",
        link: null,
        queryParams: "orderBy=lastName:ASC"
      },
      formIsValid: true,
      passwordMatched: "valid",
      activePallete: {
        pale: "#E1FAF4",
        main: "#51B67E",
        event: "#00BC8A"
      },
      memberForm: {
        displayName: null,
        firstName: null,
        lastName: null,
        email: null,
        mobile: null,
        password: null,
        confirmPassword: null,
        role: {}
      },
      selectedUserRole: "Member",
      userRoles: [],
      isToggled: false,
      btnLabel: "Create",
      editMember: false,
      editMemberId: null,
      singleMember: null
    };
  },
  computed: {
    companies() {
      let optionCompany = [];
      let companies = this.$store.state.concierge.companyList;
      if (companies.data && companies.data.length != 0) {
        Object.keys(companies.data).map(el => {
          optionCompany.push({
            label: companies.data[el].name,
            value: companies.data[el].id
          });
        });
      }
      return optionCompany;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  created() {
    this.fetchRoles();
    this.editSelectedMember();
  },
  methods: {
    ...mapActions([types.AUTH_SET]),
    editSelectedMember() {
      if (this.singleRecord) {
        this.singleMember = this.singleRecord;
        let singleMember = this.singleRecord;

        this.memberForm.displayName = singleMember.displayName;
        this.memberForm.firstName = singleMember.firstName;
        this.memberForm.lastName = singleMember.lastName;
        this.memberForm.email = singleMember.email;
        this.memberForm.mobile = singleMember.mobile;
        this.memberForm.role.value = singleMember.Roles[0].id;
        this.memberForm.role.label = singleMember.Roles[0].name;
        this.editMemberId = singleMember.id;
        this.editMember = true;
        this.btnLabel = "Update";
      }
    },
    confirmPassword() {
      this.passwordMatched = "valid";
      if (
        this.memberForm.password &&
        this.memberForm.password != this.memberForm.confirmPassword &&
        this.memberForm.confirmPassword
      ) {
        this.passwordMatched = "invalid";
      }
    },
    async handleAddNewMember() {
      this.formIsValid = true;
      let memberForm = this.memberForm;
      if (this.editMember) {
        delete memberForm.password;
        delete memberForm.confirmPassword;
      }

      Object.keys(memberForm).map(el => {
        if (
          memberForm[el] == null ||
          memberForm[el] == "" ||
          Object.entries(memberForm[el]).length == 0 ||
          !this.isPhone(memberForm["mobile"]) ||
          !this.isEmail(memberForm["email"])
        ) {
          if (memberForm[el] === null) {
            memberForm[el] = "";
          }
          if (Object.entries(memberForm["role"]).length == 0) {
            memberForm["role"] = "";
          }
          if (!this.isPhone(memberForm["mobile"])) {
            memberForm["mobile"] = "";
          }
          if (!this.isEmail(memberForm["email"])) {
            memberForm["email"] = "";
          }
          return (this.formIsValid = false);
        }
      });

      if (this.formIsValid) {
        const background = Math.floor(Math.random() * 16777215).toString(16);
        const color = Color("#" + background).isLight ? "fff" : "333";

        let form = {
          email: this.memberForm.email,
          displayName: this.memberForm.displayName,
          firstName: this.memberForm.firstName,
          lastName: this.memberForm.lastName,
          password: this.memberForm.password,
          mobile: this.memberForm.mobile,
          avatar: `https://ui-avatars.com/api/?name=${this.memberForm.firstName}+${this.memberForm.lastName}&background=${background}&color=${color}&size=500&font-size=.35&bold=true`
        };
        if (this.memberForm.role) {
          // For User/Member role
          form.UserRoles = [{ roleId: this.memberForm.role.value }];
          if (this.editMember) {
            form.UserRoles[0].id = this.singleMember.Roles[0].UserRole.id;
            form.UserRoles[0].userId = this.singleMember.id;
          }
        }
        let emailCheck = await axios.get(
          `/users?email=${this.memberForm.email}&paranoid=false`
        );
        let emailUsed = emailCheck.data.data != null ? true : false;
        if (this.editMember == false) {
          if (!emailUsed) {
            /**
             * SOCKET: New added member from concierge/admin dashboard
             */
            let logContent = `New member ${this.memberForm.firstName} ${this.memberForm.lastName} has been registered by ${this.currentUser}`;
            socketSender("newMember", logContent);
            await this.$store.dispatch("addNewMember", form);
            await this.$toastr.success("Your changes are saved", "Success");
            this.$emit("close");
          } else {
            let toastrWarning;
            if (emailCheck.data.data && emailCheck.data.data[0].deletedAt) {
              toastrWarning =
                "Email is already archived. Please change your email";
            } else {
              toastrWarning = "Email is already in used";
            }
            this.$toastr.warning(toastrWarning, "Warning");
          }
        } else {
          if (
            (emailCheck.data.data &&
              emailCheck.data.data[0].id == this.editMemberId) ||
            emailCheck.data.data == null
          ) {
            delete form.avatar;
            let data = { form: form, id: this.editMemberId };
            await this.$store.dispatch("patchMember", data);
            await this.$toastr.success("Your changes are saved", "Success");
            this.$emit("close");
          } else {
            this.$toastr.warning("Email is already used", "Warning");
          }
        }
        if (this.$route.name == "members") {
          this.$store.commit("changeActiveIndex", 0);
          this.$store.dispatch(
            "searchUsers",
            form.firstName + " " + form.lastName
          );
        } else {
          await this.$store.dispatch("fetchUsers", this.apiOptions);
        }
      } else {
        if (!this.isPhone(memberForm["mobile"])) {
          this.$toastr.error("Please input valid phone number");
        }
        if (!this.isEmail(memberForm["email"])) {
          this.$toastr.error("Please input valid email");
        }

        if (this.editMember) {
          if (
            !memberForm["firstName"] ||
            !memberForm["lastName"] ||
            !memberForm["role"]
          ) {
            this.$toastr.error("Please fill required fields");
          }
        } else {
          if (
            !memberForm["firstName"] ||
            !memberForm["lastName"] ||
            !memberForm["role"] ||
            !memberForm["confirmPassword"] ||
            !memberForm["password"]
          ) {
            this.$toastr.error("Please fill required fields");
          }
        }
      }
    },
    isPhone(num) {
      if (num != "") {
        return /^(?=.*[0-9])[- +()0-9]+$/.test(num);
      }
      return true;
    },
    isEmail(email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    handleTogglePasswordClick() {
      this.isToggled = !this.isToggled;
    },
    async fetchRoles() {
      let roles = await axios.get("/roles").then(res => {
        return res.status == 200 ? res.data : [];
      });
      Object.keys(roles.data).map(el => {
        this.userRoles.push({
          label: roles.data[el].name,
          value: roles.data[el].id
        });
      });
    },
    async handleSearchCompany(search) {
      await this.$store.dispatch("searchCompany", search);
    }
  }
};
</script>

<style lang="scss">
.form-group {
  .password-wrapper {
    position: relative;
    img {
      cursor: pointer;
      position: absolute;
      right: 0.75em;
      top: 11px;
      transition: all 0.2s ease;
      &:hover,
      &.is-visible {
        filter: brightness(50%);
      }
    }
  }
  label {
    font-weight: 500;
    font-size: $font-size-xs;
  }
  input {
    border-radius: 5px;
    color: $gray-800;
    font-family: "Gotham Book", sans-serif;
    font-size: $font-size-xs;
    &.invalid {
      border-color: red;
    }
    &.valid {
      border-color: none;
    }
  }
  ul {
    font-size: $font-size-xs;
  }
}

.dropdown-toggle {
  .vs__actions {
    button.clear {
      display: none;
    }
  }
  &::after {
    display: none !important;
  }
}
</style>
